export default __webpack_public_path__ + "static/media/G0250.CFS_v2.0_EN_Card-2Up.1686225480000.b33a7e24.jpg";